<template>
  <div class="user-agreement-page">
    <div class="content-wrap">
      <van-loading v-if="loading" class="loading" size="48" color="#1890ff" vertical>加载中...</van-loading>

      <div v-else-if="content" class="rich-content" v-html="content" />

      <div v-else class="empty-tip">暂无内容</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  data() {
    return {
      loading: true,
      content: '',
    }
  },
  mounted() {
    this.$http.oppoArticleDetail({ id: 6 })
      .then((res) => {
        this.content = (res && res.data && res.data.content) || ''
      })
      .catch(() => {
        this.$toast('协议加载失败，请重试')
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.user-agreement-page {
  min-height: 100vh;
  background: #fff;

  .mp-nav {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 88px;
    background: #fff;
    padding: 0 32px;
    border-bottom: 1px solid #f0f0f0;

    .back-btn {
      font-size: 36px;
      color: #333;
      margin-right: 20px;
      cursor: pointer;
    }

    .nav-title {
      font-size: 34px;
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .content-wrap {
    padding: 32px;

    .loading {
      padding-top: 120px;
      display: flex;
      justify-content: center;
    }

    .rich-content {
      font-size: 28px;
      line-height: 1.9;
      color: #333;

      /deep/ p { margin-bottom: 16px; }
      /deep/ h1, /deep/ h2, /deep/ h3 {
        font-weight: 700;
        margin: 24px 0 12px;
        color: #1a1a1a;
      }
      /deep/ ul, /deep/ ol {
        padding-left: 40px;
        margin-bottom: 16px;
      }
      /deep/ li { margin-bottom: 8px; }
      /deep/ table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 16px;
        font-size: 24px;
      }
      /deep/ td, /deep/ th {
        border: 1px solid #e8e8e8;
        padding: 12px 16px;
      }
      /deep/ th { background: #fafafa; font-weight: 600; }
    }

    .empty-tip {
      text-align: center;
      color: #999;
      font-size: 28px;
      padding-top: 120px;
    }
  }
}
</style>
